export default __webpack_public_path__ + "static/media/close-button.bb2ddc43.svg";